// extracted by mini-css-extract-plugin
export default {"root":"PlaceHolder_root__yL6T0"};